import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { Flex, TEXT_VARIANT_LIGHT, Text } from 'mailup-web-components'

import type { SearchResult } from 'Pages/RecipientsList/model'
import type { ActivityEmailEventType } from 'Types/beRecipientsApi'

import MessageDetails from 'Pages/RecipientsList/components/aside/activityStream/MessageDetails'

import TaskDetails from 'Pages/RecipientsList/components/aside/activityStream/TaskDetails'

interface ActivityDetailsProps {
  recipient: SearchResult
  activityType: ActivityEmailEventType
  message: {
    Id?: number
    Subject?: string
  }
  sending: {
    Type?: 'Task' | 'Workflow'
    Id?: number
  }
  channel: 'email' | 'sms'
}

const ActivityDetails: FC<ActivityDetailsProps> = ({
  activityType,
  message,
  sending,
  channel,
  recipient,
}) => {
  const intl = useIntl()

  const confirmationIP =
    channel === 'email'
      ? recipient.EmailConfirmationIP
      : recipient.SMSConfirmationIP

  const confirmationIPOut =
    typeof confirmationIP === 'string' && confirmationIP.length > 0
      ? confirmationIP
      : '-'

  const subscriptionRequestIP =
    channel === 'email'
      ? recipient.EmailSubscriptionRequestIP
      : recipient.SMSSubscriptionRequestIP

  const subscriptionRequestIPOut =
    typeof subscriptionRequestIP === 'string' &&
    subscriptionRequestIP.length > 0
      ? subscriptionRequestIP
      : '-'

  if (activityType === 'Bounces') {
    return (
      <Flex flexDirection="column" gap="4px" margin="4px 0 0 0">
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({
            id: 'Load.RecipientsList.NotDeliveredMessage',
          })}
          :
        </Text>
        <MessageDetails
          id={message.Id}
          subject={message.Subject}
          channel={channel}
        />
      </Flex>
    )
  }

  if (activityType === 'Clicks') {
    return (
      <MessageDetails
        id={message.Id}
        subject={message.Subject}
        channel={channel}
      />
    )
  }

  if (activityType === 'Opens') {
    return (
      <MessageDetails
        id={message.Id}
        subject={message.Subject}
        channel={channel}
      />
    )
  }

  if (activityType === 'Sendings') {
    return (
      <Flex flexDirection="column" gap="4px">
        <MessageDetails
          id={message.Id}
          subject={message.Subject}
          channel={channel}
        />

        <TaskDetails sending={sending} />
      </Flex>
    )
  }

  if (activityType === 'Subscription') {
    return null
  }

  if (activityType === 'SubscriptionConfirmation') {
    return <p>IP {confirmationIPOut}</p>
  }

  if (activityType === 'SubscriptionRequest') {
    return <p>IP {subscriptionRequestIPOut}</p>
  }

  return null
}

export default ActivityDetails
